import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { DOCUMENTS_BASE_PATH_FULL } from "@src/appV2/redesign/Documents/paths";
import { type ReactElement } from "react";
import { Redirect } from "react-router-dom";

/**
 * @deprecated
 * This container should no longer be used.
 * All usages should be updated to use the new redesigned document details pages, once all deep links are updated.
 */
export function DocumentDetailsPageContainer(): ReactElement {
  useLogEffect("legacy document details page container visited");

  return <Redirect to={DOCUMENTS_BASE_PATH_FULL} />;
}
